import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    // gridTemplateRows defines one shared row per card section (name, meta, price,
    // features, add-ons, CTA). Each card subgrids into these same row tracks so a
    // section lines up at the same height across every card, however much content
    // (features/add-ons) another card in the row has. Rows with no content for a
    // given plan (e.g. add-ons on a Connect plan) simply collapse to zero height.
    card: {
        position: 'relative',
        display: 'grid',
        gridTemplateRows: 'subgrid',
        rowGap: 2,
        gridRow: 'span 6',
        backgroundColor: '#ffffff',
        borderRadius: 8,
        border: `1px solid ${theme.palette.grey[100]}`,
        boxShadow: '0px 3px 11px 0px #E8EAFC',
        padding: 24,
    },
    cardPopular: ({ accentColor }) => ({
        border: `2px solid ${accentColor || theme.palette.primary.main}`,
        boxShadow: '0px 8px 24px 0px rgba(0, 0, 130, 0.18)',
    }),
    // Absolute corner placement for the CURRENT/MOST POPULAR badges — the pill's own
    // color/shape lives in Billing/Pill; only positioning is this card's concern.
    // Clips the rotated CURRENT ribbon (and its fold-flap pseudo-elements) to the
    // card's top-right corner so it doesn't spill past the card edges.
    currentRibbonWrap: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 100,
        height: 100,
        overflow: 'hidden',
        pointerEvents: 'none',
    },
    pillPopularPosition: {
        position: 'absolute',
        top: -12,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    planName: {
        gridRow: 1,
        marginBottom: 8,
        fontWeight: 700,
    },
    meta: {
        gridRow: 2,
    },
    description: {
        color: theme.palette.text.secondary,
    },
    summary: {
        fontWeight: 600,
        marginTop: 8,
    },
    priceRow: {
        gridRow: 3,
        display: 'flex',
        alignItems: 'baseline',
        gap: 4,
        margin: '16px 0 4px',
    },
    priceAmount: {
        fontSize: 36,
        fontWeight: 700,
        lineHeight: 1,
    },
    pricePeriod: {
        color: theme.palette.text.secondary,
    },
    features: {
        gridRow: 4,
        listStyle: 'none',
        padding: 0,
        margin: '16px 0 0',
    },
    feature: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        marginBottom: 8,
    },
    checkIcon: {
        color: theme.palette.success.main,
        fontSize: 18,
        marginTop: 2,
        flexShrink: 0,
    },
    // Add-ons section, pinned to its own shared grid row (see `card` above) so the
    // divider/toggle line up across cards regardless of how many features/add-ons
    // a given plan lists. Renders nothing (and takes no row height) for plans with
    // no add-ons, e.g. Connect plans.
    addOns: {
        gridRow: 5,
        marginTop: 20,
        paddingTop: 16,
        borderTop: `1px solid ${theme.palette.grey[100]}`,
    },
    addOnsToggle: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: 'none',
        border: 'none',
        padding: 0,
        marginBottom: 24,
        textAlign: 'left',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 14,
        color: 'inherit',
        fontFamily: theme.typography.fontFamily,
    },
    addOnsToggleIcon: {
        transition: 'transform 0.2s',
        flexShrink: 0,
    },
    addOnsToggleIconExpanded: {
        transform: 'rotate(180deg)',
    },
    addOnRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 12,
        marginBottom: 16,
    },
    addOnInfo: {
        flex: 1,
        minWidth: 0,
    },
    addOnName: {
        fontWeight: 600,
    },
    addOnPrice: {
        display: 'block',
        marginTop: 2,
        color: '#4a4a52',
        fontSize: 13,
    },
    addOnPriceValue: {
        fontWeight: 600,
    },
    addOnDesc: {
        color: theme.palette.text.secondary,
        marginTop: 4,
    },
    addOnControl: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        minWidth: 88,
        justifyContent: 'flex-end',
    },
    cta: {
        gridRow: 6,
        marginTop: 20,
    },
}));
